module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_header_2-1bd7de28407b03525474e9aac8acb779.jpg";